export default __webpack_public_path__ + "static/media/cart.b51230c1.gif";